export enum LinkType {
    logo = 'LOGO',
    manulifeWord = 'ManulifeWord'
  }